import React, { useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import NumberFormat from 'react-number-format';
import { Container, Row, Modal, Col } from 'react-bootstrap';
import { TextInputMultiple, CheckboxInput } from '../../Helpers/Inputs';
import { getSessionStorageItem, ADVISOR_OBJECT_KEY } from '../../../sessionStorage';
import { httpRequest } from '../../../httpRequest';
import './Note.scss';
import constants from '../../../constants';

const Note = props => {

  const [noteInput, setNoteInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isShared, setIsShared] = useState(false)

  let advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  let role = advisorObj && advisorObj.role;

  const clearFields = () => {
    setNoteInput('');
  }
  const handleSaveNotes = () => {
    let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
    //show loader
    setIsLoading(true);
    httpRequest.get(`${baseAddress}/api/MorganStanley/CreateCaseNote?caseId=${props.details.caseID ? props.details.caseID : props.details.conciergeCaseID}&caseTypeID=${props.details.caseID ? 1 : 2}&note=${noteInput}&shared=${true}`)
      .then((data) => {
        if (data.success) {
          setIsLoading(false);
          props.onSaveNoteSuccess();
          clearFields();
        }
        else{
            setIsLoading(false);
            props.onSaveNoteFailure();
        }
      })
      .catch(() => {
        setIsLoading(false);
        props.onSaveNoteFailure();
      });
  }
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="md" backdrop="static" centered dialogClassName="custom-dialog">
      <Modal.Body className="show-grid approve-dialog">
        <Container>
          <Row className="modal-design pt-8">
            <div className="head-text pl-0 text-center">Add Notes</div>
            <div className="close-icon-section">
              <IconButton
                aria-label="close"
                onClick={() => {
                  clearFields();
                  props.onHide();
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </Row>
          <Row>
            <Col>
              <div className="text-center">
                {props.details.firstName + ' ' + props.details.lastName} -{' '}
                {(props.details.faceAmount ? <NumberFormat displayType={'text'} prefix={'$'} value={props.details.faceAmount} thousandSeparator={true} /> : '') ||
                  'Coverage Amount Unknown'}{' '}
                - {props.details.carrier || 'Carrier Unknown'}
              </div>
            </Col>
          </Row>
          <div className="content-spacing mb-2">Notes</div>
          <Row>
            <Col>
              <TextInputMultiple
                name={noteInput}
                id={noteInput}
                label="Notes"
                value={noteInput}
                onChange={(e) => setNoteInput(e.target.value)}
              />
              {(role === constants.cruRole) && 
                <CheckboxInput
                  name="isShared"
                  id="isShared"
                  checked={isShared}
                  onChange={(e) => setIsShared(e.target.checked)}
                  label="Share note with Financial Advisor"
                  color="primary"
                />
              }
            </Col>
          </Row>
          <Row className="content-spacing">
            <Col className="text-center">
              <div className="buttons-spacing">
                {isLoading ? (
                  <Button className="primary-button button-width">
                    <CircularProgress className="circular-progress" />
                  </Button>
                ) : (
                  <Button
                    className={`button-width ${!noteInput ? 'primary-button-disabled' : 'primary-button'}`}
                    disabled={!noteInput}
                    onClick={() => handleSaveNotes()}
                  >
                    SAVE
                  </Button>
                )}
              </div>
              <div className="buttons-spacing">
                <Button
                  className="secondary-button"
                  onClick={() => {
                    clearFields();
                    props.onHide();
                  }}
                  color="primary"
                >
                  CANCEL
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
export default Note;


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/Note.js